import { create } from 'zustand'

interface PullToRefreshLockState {
  /** Contagem de consumidores que pedem bloqueio (diálogos abertos). */
  lockCount: number
  /** True quando pelo menos um consumidor pediu bloqueio. */
  locked: boolean
  /** Incrementa o lock (chamar ao montar diálogo). */
  lock: () => void
  /** Decrementa o lock (chamar ao desmontar diálogo). */
  unlock: () => void
}

/**
 * Store global para bloquear pull-to-refresh quando diálogos/modais estão abertos.
 *
 * Uso: diálogos chamam `lock()` no mount e `unlock()` no cleanup via useEffect.
 * PullToRefresh lê `locked` para ignorar gestos.
 *
 * Usa contagem (não booleano) para suportar diálogos aninhados.
 */
export const usePullToRefreshLock = create<PullToRefreshLockState>((set) => ({
  lockCount: 0,
  locked: false,
  lock: () =>
    set((state) => {
      const next = state.lockCount + 1
      return { lockCount: next, locked: next > 0 }
    }),
  unlock: () =>
    set((state) => {
      const next = Math.max(0, state.lockCount - 1)
      return { lockCount: next, locked: next > 0 }
    }),
}))
